import "./MoreInformation.css";

export const GoodLeaver = (
  <div className="info-container small flex flex-row mr-auto ml-auto">
    <div className="info-column small flex flex-column ">
      <text className="sub-title">Good leaver</text>
      <text className="paragraph">
        A "good leaver" is a term used in founder vesting agreements to describe
        a founder who leaves the company prior to the end of the vesting period
        under specific circumstances but (i) often for a good reason or (ii) for
        reasons beyond their control. The consequence however is that the
        Founder is not able to commit any professional time to the company.
      </text>
      <text className="paragraph">
        The reason why a distinction is made between good, early and bad leaver,
        is because, typically a different price is agreed upon for the shares. A
        good leaver is typically treated better than an early leaver and early
        leaver is typically treated better than a bad leaver.
      </text>
    </div>
  </div>
);
